import { inject } from '@angular/core';
import { RedirectCommand, Router, type CanActivateFn } from '@angular/router';
import { AppRouting } from '@core/enums';
import { Store } from '@ngrx/store';
import { userFeature } from '@src/state';
import { map } from 'rxjs';

export const limitedGuard: CanActivateFn = (route, state) => {
  const store = inject(Store);
  const router = inject(Router);

  return store
    .select(userFeature.selectIsMsisdnLimited)
    .pipe(
      map((isLimited) =>
        isLimited
          ? new RedirectCommand(router.parseUrl(`/${AppRouting.LimitedUser}`))
          : true
      )
    );
};
